import { call, put, takeLatest, all } from 'redux-saga/effects';
import api from '../../../utils/tt-api';
import Actions, { ActionTypes } from './actions';
import notification from '@tt/components/Notification';
import { CONSTANT_VARIABLES } from '../../../views/common/Constant_Variables/constants';

function* fetchAll({ params }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects`,
      params: params,
    });
    const allVisionProjects = data?.toJS() ?? { item1: [], item2: 0 };
    yield put(Actions.setAll({ allVisionProjects }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* fetchProjectById({ projectId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects/${projectId}`,
    });
    const projectDetails = data.toJS();
    yield put(Actions.setProjectDetails({ projectDetails }));
    // Fetch global and customer AOIs for the combined selector
    yield put(Actions.fetchAllGlobalAois());
    yield put(Actions.fetchCustomerAois());
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err.exceptionContent, '');
    console.warn(err); // Handle exception
  }
}
function* fetchAllUseCases() {
  try {
    yield put(Actions.setModalLoader({ showModalLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionUseCases`,
    });
    const useCases = data?.toJS() ?? [];
    yield put(Actions.setAllUseCases({ useCases }));
    yield put(Actions.setModalLoader({ showModalLoader: false }));
  } catch (err) {
    yield put(Actions.setModalLoader({ showModalLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* getVideos({ id }) {
  try {
    yield put(Actions.setVideoTableLoader({ showVideoTableLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects/${id}/Videos`,
    });
    const allVideos = data.toJS() ?? { item1: [], item2: 0 };
    yield put(Actions.setVideos({ allVideos }));
    yield put(Actions.setVideoTableLoader({ showVideoTableLoader: false }));
  } catch (err) {
    yield put(Actions.setVideoTableLoader({ showVideoTableLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addVisionProject({ data, callback }) {
  try {
    yield put(Actions.setModalLoader({ showModalLoader: true }));
    yield call(api.post, {
      route: `VisionProjects`,
      data: data,
    });
    yield put(Actions.setModalLoader({ showModalLoader: false }));
    if (callback) {
      callback();
    }
    notification('success', CONSTANT_VARIABLES.VISION_PROJECT_ADD_SUCCESSFULLY, '');
  } catch (err) {
    yield put(Actions.setModalLoader({ showModalLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* updateVisionProject({ data, id, callback }) {
  try {
    yield put(Actions.setModalLoader({ showModalLoader: true }));
    yield call(api.put, {
      route: `VisionProjects/${id}`,
      data: data,
    });
    yield put(Actions.setModalLoader({ showModalLoader: false }));

    notification('success', CONSTANT_VARIABLES.VISION_PROJECT_UPDATE_SUCCESSFULLY, '');
    if (callback) {
      callback();
    }
  } catch (err) {
    yield put(Actions.setModalLoader({ showModalLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* updateVisionProjectArtwork({ data, id }) {
  try {
    yield put(Actions.setModalLoader({ showLoader: true }));
    yield call(api.put, {
      route: `VisionProjects/${id}/Artwork`,
      data: data,
    });
    yield put(Actions.setModalLoader({ showLoader: false }));

    notification('success', CONSTANT_VARIABLES.VISION_PROJECT_ARTWORK_UPDATE_SUCCESSFULLY, '');
    yield put(Actions.fetchProjectById({ projectId: id }));
  } catch (err) {
    yield put(Actions.setModalLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}
function* deleteVisionProject({ id, params }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `VisionProjects/${id}`,
    });
    yield put(Actions.setLoader({ showLoader: false }));

    notification('success', CONSTANT_VARIABLES.VISION_PROJECT_DELETE_SUCCESSFULLY, '');
    yield put(Actions.fetchAll({ params }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* deleteVisionProjectArtwork({ id }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `VisionProjects/${id}/Artwork`,
    });
    yield put(Actions.setLoader({ showLoader: false }));

    notification('success', CONSTANT_VARIABLES.VISION_PROJECT_ARTWORK_DELETE_SUCCESSFULLY, '');
    yield put(Actions.fetchProjectById({ projectId: id }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* deleteVisionProjectVideo({ id, fileName, callback }) {
  try {
    yield put(Actions.setVideoTableLoader({ showVideoTableLoader: true }));
    yield call(api.delete, {
      route: `VisionProjects/${id}/Videos/${fileName}`,
    });
    yield put(Actions.setVideoTableLoader({ showVideoTableLoader: false }));

    if (callback) {
      callback(true);
    }
    notification('success', CONSTANT_VARIABLES.VISION_PROJECT_VIDEO_DELETE_SUCCESSFULLY, '');
  } catch (err) {
    yield put(Actions.setVideoTableLoader({ showVideoTableLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* deleteVisionProjectImage({ id, fileName, callback, skipNotification }) {
  try {
    yield put(Actions.setTableLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `VisionProjects/${id}/Images`,
      data: { fileName },
    });
    yield put(Actions.setTableLoader({ showLoader: false }));

    if (callback) {
      callback(true);
    }
    if (!skipNotification) {
      notification('success', CONSTANT_VARIABLES.VISION_PROJECT_IMAGE_DELETE_SUCCESSFULLY, '');
    }
  } catch (err) {
    yield put(Actions.setTableLoader({ showLoader: false }));
    if (callback) {
      callback(false);
    }
    if (!skipNotification) {
      notification('error', err, '');
    }
    console.warn(err); // Handle exception
  }
}

function* deleteProductFromProject({ productId, id }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `VisionProjects/${id}/Product/${productId}`,
    });
    yield put(Actions.setLoader({ showLoader: false }));

    notification('success', CONSTANT_VARIABLES.VISION_PROJECT_PRODUCT_DELETE_SUCCESSFULLY, '');
    yield put(Actions.fetchProjectById({ projectId: id }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* uploadImages({ data, id, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    let response = yield call(api.put, {
      route: `VisionProjects/${id}/Images`,
      data: data,
    });
    yield put(Actions.setLoader({ showLoader: false }));

    const result = response.data.toJS();
    if (callback) {
      callback(result);
    }
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* uploadVideo({ data, id, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    let result = yield call(api.put, {
      route: `VisionProjects/${id}/Videos`,
      data: data,
    });
    yield put(Actions.setLoader({ showLoader: false }));

    if (callback) {
      callback(result.data.toJS());
    }
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* uploadMedia({ id, data, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    let response = yield call(api.put, {
      route: `VisionProjects/${id}/Files`,
      data: data,
    });
    yield put(Actions.setLoader({ showLoader: false }));

    const result = response.data?.toJS ? response.data.toJS() : response.data;
    yield put(Actions.setMediaUploadResult({ mediaUploadResult: result }));
    if (callback) {
      callback(result);
    }
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err);
    if (callback) callback({ success: false, error: err });
  }
}

function* fetchImages({ id, imageParams }) {
  try {
    yield put(Actions.setTableLoader({ showTableLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects/${id}/Images`,
      params: imageParams,
    });
    const allImages = data?.toJS() ?? { item1: [], item2: 0 };
    yield put(Actions.setImages({ allImages }));
    yield put(Actions.setTableLoader({ showTableLoader: false }));
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchImageAnnotations({ projectId, imageId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects/${projectId}/annotations/${imageId}`,
    });
    const imageAnnotations = data?.toJS() ?? null;
    yield put(Actions.setImageAnnotations({ imageAnnotations }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* addAnnotationsToImage({ data }) {
  const { projectId, imageId, skipRefetch } = data;
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.post, {
      route: `VisionProjects/${projectId}/annotations/${imageId}`,
      data: data,
    });

    yield put(Actions.setLoader({ showLoader: false }));
    notification('success', CONSTANT_VARIABLES.VISION_PROJECT_IMAGE_ANNOTATIONS_ADD_SUCCESSFULLY, '');

    // Only refetch if not explicitly skipped (for bulk saves)
    if (!skipRefetch) {
      yield put(Actions.fetchImages({ id: projectId, imageParams: { pageNo: 0, pageSize: 100, getAll: true } }));
      yield put(Actions.fetchProjectById({ projectId: projectId }));
    }
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    notification('info', CONSTANT_VARIABLES.VISION_PROJECT_IMAGE_ANNOTATIONS_ERROR, '');
    console.warn(err);
  }
}

function* updateAnnotationsOfImage({ data }) {
  const { projectId, imageId, skipRefetch } = data;
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, {
      route: `VisionProjects/${projectId}/annotations/${imageId}`,
      data: data,
    });

    yield put(Actions.setLoader({ showLoader: false }));
    notification('success', CONSTANT_VARIABLES.VISION_PROJECT_IMAGE_ANNOTATIONS_UPDATE_SUCCESSFULLY, '');

    // Only refetch if not explicitly skipped (for bulk saves)
    if (!skipRefetch) {
      yield put(Actions.fetchImages({ id: projectId, imageParams: { pageNo: 0, pageSize: 100, getAll: true } }));
      yield put(Actions.fetchProjectById({ projectId: projectId }));
    }
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    notification('info', CONSTANT_VARIABLES.VISION_PROJECT_IMAGE_ANNOTATIONS_ERROR, '');
    console.warn(err);
  }
}

function* saveAnnotationsBulk({ projectId, items, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const response = yield call(api.post, {
      route: `VisionProjects/${projectId}/annotations/bulk`,
      data: { items },
    });

    yield put(Actions.setLoader({ showLoader: false }));
    notification('success', CONSTANT_VARIABLES.VISION_PROJECT_IMAGE_ANNOTATIONS_BULK_SAVE_SUCCESSFULLY, '');

    if (callback) {
      const payload = response?.data?.toJS ? response.data.toJS() : response?.data;
      callback({ success: true, data: payload });
    }
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('info', CONSTANT_VARIABLES.VISION_PROJECT_IMAGE_ANNOTATIONS_ERROR, '');
    console.warn(err);
    if (callback) {
      callback({ success: false, error: err });
    }
  }
}

function* deleteAnnotationsOfImage({ annotationData }) {
  const { projectId, imageId } = annotationData;
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `VisionProjects/${projectId}/annotations/${imageId}`,
      data: annotationData,
    });

    yield put(Actions.setLoader({ showLoader: false }));
    notification('success', CONSTANT_VARIABLES.VISION_PROJECT_IMAGE_ANNOTATIONS_DELETE_SUCCESSFULLY, '');

    yield put(Actions.fetchProjectById({ projectId: projectId }));
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* startTraining({ projectId, userId, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    let data = yield call(api.post, {
      route: `VisionProjects/${projectId}/training/userId/${userId}`,
    });

    if (data) {
      if (callback) callback();
    }
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.fetchProjectById({ projectId: projectId }));
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    console.error(err); // Handle exception
    notification('error', CONSTANT_VARIABLES.VISION_PROJECT_TRAINING_STOPPED_FAILED, '');

    yield put(Actions.setLoader({ showLoader: false }));
  }
}

function* stopTraining({ projectId, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    let data = yield call(api.post, {
      route: `VisionProjects/${projectId}/stopTraining`,
    });

    if (data) {
      if (callback) callback();
    }
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.getTrainingHistory({ id: projectId }));
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    console.error(err); // Handle exception
    notification('error', 'Training stop failed', '');

    yield put(Actions.setLoader({ showLoader: false }));
  }
}

function* fetchTrainingProgress({ projectId }) {
  try {
    const { data } = yield call(api.get, {
      route: `VisionProjects/${projectId}/training/progress`,
    });

    const trainingProgress = data ? data.toJS() : null;
    yield put(Actions.setTrainingProgress({ trainingProgress }));

    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    console.error(err); // Handle exception
  }
}

function* updateStep({ stepParams }) {
  try {
    const { projectId, currentStep } = stepParams;
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, {
      route: `VisionProjects/${projectId}/step/${currentStep}`,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.fetchProjectById({ projectId }));
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* fetchTrainingData({ projectId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects/${projectId}/training`,
    });

    const trainingData = data ? data.toJS() : null;
    yield put(Actions.setTrainingData({ trainingData }));

    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* testModel({ projectId, image, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.post, {
      route: `VisionProjects/${projectId}/test`,
      data: { image },
    });

    const testModelResult = data ? data.toJS() : null;
    yield put(Actions.setTestModelResult({ testModelResult }));
    yield put(Actions.setLoader({ showLoader: false }));
    if (callback) {
      callback();
    }
  } catch (err) {
    console.warn(err);
  }
}
function* fetchTestResult({ projectId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects/${projectId}/test`,
    });

    const testModelResult = data ? data.toJS() : null;
    yield put(Actions.setTestModelResult({ testModelResult }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    console.warn(err);
  }
}

function* configureProject({ projectId, jsonContent, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.put, {
      route: `VisionProjects/${projectId}/configuration/json`,
      data: { jsonContent },
    });
    yield put(Actions.setLoader({ showLoader: false }));

    let response = data.toJS();

    if (response.isError) {
      if (response.invalidAttributes?.length) {
        callback(response.invalidAttributes);
      } else {
        notification('error', 'Error', response.message || 'Something went wrong.');
      }
    } else {
      yield put(Actions.fetchProjectById({ projectId }));
      notification('success', 'Success', response.message || 'JSON configuration has been saved successfully.');
    }
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', 'Error', err.message || err.toString());
    console.warn(err); // Handle exception
  }
}

function* deployModel({ projectId, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.post, {
      route: `VisionProjects/${projectId}/deployModel`,
    });

    yield put(Actions.setLoader({ showLoader: false }));

    if (data) {
      notification('success', CONSTANT_VARIABLES.VISION_PROJECT_MODEL_DEPLOYED_SUCCESSFULLY, '');
      if (callback) {
        callback();
      }
    } else {
      notification('error', CONSTANT_VARIABLES.VISION_PROJECT_MODEL_DEPLOY_FAILED, '');
    }
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', CONSTANT_VARIABLES.VISION_PROJECT_MODEL_DEPLOY_ERROR, '');
    console.warn(err);
  }
}

function* fetchDeployedVisionProjectsByProductId({ productId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    let { data } = yield call(api.get, {
      route: `VisionProjects/${productId}/deployed`,
    });

    const deployedVisionProjects = data?.toJS() ?? [];
    yield put(Actions.setDeployedVisionProjects({ deployedVisionProjects }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* removeAnnotations({ projectId, annotationId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.put, {
      route: `VisionProjects/${projectId}/removeAnnotation/${annotationId}`,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.fetchProjectById({ projectId: projectId }));
    yield put(Actions.fetchImages({ id: projectId, imageParams: { pageNo: 0, pageSize: 100, getAll: true } }));
  } catch (err) {
    yield put(Actions.setTableLoader({ showTableLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* getDeploymentHistory({ id }) {
  try {
    yield put(Actions.setDeploymentHistoryLoader({ showDeploymentHistoryLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects/${id}/deploymentHistory`,
    });
    const allDeploymentHistory = data;
    yield put(Actions.setDeploymentHistory({ allDeploymentHistory }));
    yield put(Actions.setDeploymentHistoryLoader({ showDeploymentHistoryLoader: false }));
  } catch (err) {
    yield put(Actions.setDeploymentHistoryLoader({ showDeploymentHistoryLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* checkCameraStatus({ deviceId }) {
  try {
    yield put(Actions.setCameraStatusLoader({ showCameraStatusLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects/CheckCameraHealth/${deviceId}`,
    });
    yield put(Actions.setCameraStatus({ cameraStatus: data }));
    yield put(Actions.setCameraStatusLoader({ showCameraStatusLoader: false }));
  } catch (err) {
    yield put(Actions.setCameraStatusLoader({ showCameraStatusLoader: false }));
    notification('error', err, '');
    console.warn(err);
  }
}

function* getImageFromS3Bucket({ projectId }) {
  try {
    const { data } = yield call(api.get, {
      route: `VisionProjects/GetImageFromS3Bucket/${projectId}`,
    });
    yield put(Actions.setImageFromS3Bucket({ imageData: data }));
  } catch (err) {
    notification('error', err, '');
    console.warn(err);
  }
}

function* imageCaptureStartStop({ deviceId, action, callback }) {
  try {
    yield put(Actions.setStartStopLoader({ showStartStopLoader: true }));
    let response = yield call(api.post, {
      route: `VisionProjects/ImageCaptureStart/${deviceId}`,
      data: action,
    });
    const result = response.data.toJS();
    yield put(Actions.setStartStopLoader({ showStartStopLoader: false }));
    if (callback) {
      callback(result);
    }
  } catch (err) {
    yield put(Actions.setStartStopLoader({ showStartStopLoader: true }));
    notification('error', err, '');
    if (callback) callback({ status: 'error', error: err });
    console.warn(err);
  }
}

function* deleteSingleImageFromS3({ imageKey, projectId }) {
  try {
    yield put(Actions.setDeleteImageLoader({ showDeleteImageLoader: true }));
    yield call(api.delete, {
      route: `VisionProjects/DeleteSingleImageFromS3`,
      params: { imageKey },
    });
    yield put(Actions.setDeleteImageLoader({ showDeleteImageLoader: false }));
    // Optionally refresh images after delete
    yield put(Actions.getImageFromS3Bucket({ projectId }));
    notification('success', 'Image deleted successfully', '');
  } catch (err) {
    yield put(Actions.setDeleteImageLoader({ showDeleteImageLoader: true }));
    notification('error', err, '');
    console.warn(err);
  }
}

function* deleteAllImagesFromS3Bucket({ projectId }) {
  try {
    yield put(Actions.setDeleteAllLoader({ showDeleteAllLoader: true }));
    yield call(api.delete, {
      route: `VisionProjects/DeleteAllImagesFromS3Bucket/${projectId}`,
    });
    yield put(Actions.getImageFromS3Bucket({ projectId }));
    notification('success', 'All images deleted successfully', '');
    yield put(Actions.setDeleteAllLoader({ showDeleteAllLoader: false }));
  } catch (err) {
    yield put(Actions.setDeleteAllLoader({ showDeleteAllLoader: false }));
    notification('error', err, '');
    console.warn(err);
  }
}

function* uploadImagesToMongoDb({ images, projectId, batchId, uploadedBy, callback }) {
  try {
    yield put(Actions.setUploadImageLoader({ showUploadImageLoader: true }));
    const queryParams = new URLSearchParams();
    if (batchId) queryParams.append('batchId', batchId);
    if (uploadedBy) queryParams.append('uploadedBy', uploadedBy);
    const queryString = queryParams.toString();
    let response = yield call(api.put, {
      route: `VisionProjects/${projectId}/UploadImagesToMongo${queryString ? `?${queryString}` : ''}`,
      data: images,
    });
    const result = response.data.toJS();
    yield put(Actions.setUploadImageLoader({ showUploadImageLoader: false }));
    if (callback) {
      callback(result);
    }
  } catch (err) {
    yield put(Actions.setUploadImageLoader({ showUploadImageLoader: false }));
    notification('error', err, '');
    if (callback) callback({ success: false, error: err });
  }
}

function* isImageCaptureProcessed({ projectId, deviceId }) {
  try {
    const { data } = yield call(api.get, {
      route: `VisionProjects/IsImageCaptureProcessed/${projectId}/${deviceId}`,
    });
    yield put(Actions.setImageCaptureProcessed({ isProcessed: data }));
  } catch (err) {
    notification('error', err, '');
    yield put(Actions.setImageCaptureProcessed({ isProcessed: false }));
  }
}

function* getTrainingHistory({ id }) {
  try {
    yield put(Actions.setTrainingHistoryLoader({ showTrainingHistoryLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects/${id}/trainingHistory`,
    });
    const allTrainingHistory = data;
    yield put(Actions.setTrainingHistory({ allTrainingHistory }));
    yield put(Actions.setTrainingHistoryLoader({ showTrainingHistoryLoader: false }));
  } catch (err) {
    yield put(Actions.setTrainingHistoryLoader({ showTrainingHistoryLoader: false }));
    notification('error', err, '');
    console.warn(err); // Handle exception
  }
}

function* getVisionProjectStatus({ productId, callback }) {
  try {
    const { data } = yield call(api.get, {
      route: `VisionProjects/${productId}/GetVisionProjectStatus`,
    });
    // Assuming API returns { status: true/false }
    const status = typeof data === 'boolean' ? data : data.status;
    yield put(Actions.setVisionProjectStatus({ status }));
    if (callback) {
      callback(status);
    }
  } catch (err) {
    yield put(Actions.setVisionProjectStatus({ status: false }));
    notification('error', err, '');
    console.warn(err);
  }
}

function* fetchVisionAiTools() {
  yield put(Actions.setLoader({ showLoader: true }));
  try {
    const { data } = yield call(api.get, {
      route: `VisionProjects/aiTools`,
    });
    const visionProjectAiTools = data;
    yield put(Actions.setVisionAiTools({ visionProjectAiTools }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    notification('error', error, '');
    console.warn(error);
  }
}

function* saveTempAnnotation({ projectId, imageId, annotations, callback }) {
  try {
    const { data } = yield call(api.post, {
      route: `VisionProjects/${projectId}/temp-annotations/${imageId}`,
      data: { annotations },
    });
    if (callback) {
      callback({ success: true, data });
    }
  } catch (error) {
    console.warn('Failed to save temp annotation:', error);
    if (callback) {
      callback({ success: false, error });
    }
  }
}

function* fetchTempAnnotations({ projectId, callback }) {
  try {
    const { data } = yield call(api.get, {
      route: `VisionProjects/${projectId}/temp-annotations`,
    });
    const tempAnnotations = data?.toJS ? data.toJS() : data || [];
    yield put(Actions.setTempAnnotations({ tempAnnotations }));
    if (callback) {
      // Normalize property names to handle both camelCase and PascalCase
      const normalizedData = tempAnnotations.map(temp => ({
        imageId: temp.imageId || temp.ImageId,
        annotations: temp.annotations || temp.Annotations || [],
        status: temp.status || temp.Status,
        projectId: temp.projectId || temp.ProjectId,
      }));
      callback({ success: true, data: normalizedData });
    }
  } catch (error) {
    console.warn('Failed to fetch temp annotations:', error);
    if (callback) {
      callback({ success: false, error });
    }
  }
}

function* fetchTempAnnotationByImage({ projectId, imageId, callback }) {
  try {
    const { data } = yield call(api.get, {
      route: `VisionProjects/${projectId}/temp-annotations/${imageId}`,
    });
    const tempAnnotation = data?.toJS ? data.toJS() : data;
    if (callback) {
      // Normalize property names to handle both camelCase and PascalCase
      if (tempAnnotation) {
        const normalizedData = {
          imageId: tempAnnotation.imageId || tempAnnotation.ImageId,
          annotations: tempAnnotation.annotations || tempAnnotation.Annotations || [],
          status: tempAnnotation.status || tempAnnotation.Status,
          projectId: tempAnnotation.projectId || tempAnnotation.ProjectId,
        };
        callback({ success: true, data: normalizedData });
      } else {
        callback({ success: true, data: null });
      }
    }
  } catch (error) {
    console.warn('Failed to fetch temp annotation by image:', error);
    if (callback) {
      callback({ success: false, error });
    }
  }
}

// AOI saga handlers
function* fetchAllGlobalAois() {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects/aois/global`,
    });
    const allGlobalAois = data || [];
    yield put(Actions.setAllGlobalAois({ allGlobalAois }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', error?.exceptionContent || error?.message || 'Failed to fetch global AOIs', '');
    console.warn(error);
  }
}

function* fetchCustomerAois() {
  try {
    const { data } = yield call(api.get, {
      route: `VisionProjects/aois`,
    });
    const customerAois = data || null;
    yield put(Actions.setCustomerAois({ customerAois }));
  } catch (error) {
    notification('error', error?.exceptionContent || error?.message || 'Failed to fetch customer AOIs', '');
    console.warn(error);
  }
}

function* fetchLabelsList() {
  try {
    const { data } = yield call(api.get, {
      route: `VisionProjects/aois/labels-list`,
    });
    const labelsList = data || [];
    yield put(Actions.setLabelsList({ labelsList }));
  } catch (error) {
    notification('error', error?.exceptionContent || error?.message || 'Failed to fetch labels list', '');
    console.warn(error);
  }
}

function* saveCustomerAoiSelection({ globalAois, projectId, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.put, {
      route: `VisionProjects/aois/selected`,
      data: { globalAois, projectId },
    });
    yield put(Actions.setCustomerAois({ customerAois: data }));
    yield put(Actions.fetchLabelsList());
    if (projectId) {
      yield put(Actions.fetchProjectById({ projectId }));
    }
    yield put(Actions.setLoader({ showLoader: false }));
    if (callback) callback();
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', error?.exceptionContent || error?.message || 'Failed to save AOI selection', '');
    console.warn(error);
  }
}

function* addCustomerAoi({ aoiData, projectId, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.post, {
      route: `VisionProjects/aois`,
      data: { ...aoiData, projectId },
    });
    if (callback) callback();
    yield put(Actions.fetchCustomerAois());
    yield put(Actions.fetchLabelsList());
    if (projectId) {
      yield put(Actions.fetchProjectById({ projectId }));
    }
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', error?.exceptionContent || error?.message || 'Failed to add custom AOI', '');
    console.warn(error);
  }
}

function* updateCustomerAoi({ aoiData, projectId, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const aoiIndex = aoiData.id || aoiData.index;
    yield call(api.put, {
      route: `VisionProjects/aois/${aoiIndex}`,
      data: { ...aoiData, projectId },
    });
    if (callback) callback();
    yield put(Actions.fetchCustomerAois());
    yield put(Actions.fetchLabelsList());
    if (projectId) {
      yield put(Actions.fetchProjectById({ projectId }));
    }
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', error?.exceptionContent || error?.message || 'Failed to update custom AOI', '');
    console.warn(error);
  }
}

function* deleteCustomerAoi({ aoiIndex, projectId, callback, errorCallback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `VisionProjects/aois/${aoiIndex}`,
      data: projectId ? { projectId } : undefined,
    });
    if (callback) callback();
    yield put(Actions.fetchCustomerAois());
    yield put(Actions.fetchLabelsList());
    if (projectId) {
      yield put(Actions.fetchProjectById({ projectId }));
    }
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    const errorMessage = error?.exceptionContent || error?.message || 'Failed to delete custom AOI';
    if (errorCallback) {
      errorCallback(errorMessage);
    } else {
      notification('error', errorMessage, '');
    }
    console.warn(error);
  }
}

function* removeGlobalAoiSelection({ aoiIndex, projectId, callback, errorCallback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    yield call(api.delete, {
      route: `VisionProjects/aois/${aoiIndex}`,
      data: projectId ? { projectId } : undefined,
    });
    if (callback) callback();
    yield put(Actions.fetchCustomerAois());
    yield put(Actions.fetchLabelsList());
    if (projectId) {
      yield put(Actions.fetchProjectById({ projectId }));
    }
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (error) {
    yield put(Actions.setLoader({ showLoader: false }));
    const errorMessage = error?.exceptionContent || error?.message || 'Failed to remove global AOI';
    if (errorCallback) {
      errorCallback(errorMessage);
    } else {
      notification('error', errorMessage, '');
    }
    console.warn(error);
  }
}

// Batch operations
function* fetchBatches({ projectId }) {
  try {
    const { data } = yield call(api.get, {
      route: `VisionProjects/${projectId}/batches`,
    });
    yield put(Actions.setBatches({ batches: data }));
  } catch (err) {
    notification('error', err?.response?.data?.message || err?.message || 'Failed to fetch batches', '');
    console.warn('Failed to fetch batches:', err);
  }
}

function* deleteBatch({ projectId, batchId, statusFilter, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const queryParams = statusFilter ? `?statusFilter=${statusFilter}` : '';
    yield call(api.delete, {
      route: `VisionProjects/${projectId}/batches/${batchId}${queryParams}`,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    notification('success', 'Images deleted successfully', '');
    if (callback) callback(true);
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err?.response?.data?.message || err?.message || 'Failed to delete images', '');
    if (callback) callback(false);
    console.warn(err);
  }
}

function* markBatchAsNull({ projectId, batchId, statusFilter, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const queryParams = statusFilter ? `?statusFilter=${statusFilter}` : '';
    yield call(api.post, {
      route: `VisionProjects/${projectId}/batches/${batchId}/mark-null${queryParams}`,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    notification('success', 'Batch marked as null successfully', '');
    if (callback) callback(true);
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err?.response?.data?.message || err?.message || 'Failed to mark batch as null', '');
    if (callback) callback(false);
    console.warn(err);
  }
}

function* moveBatchToRaw({ projectId, batchId, statusFilter, callback }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const queryParams = statusFilter ? `?statusFilter=${statusFilter}` : '';
    yield call(api.post, {
      route: `VisionProjects/${projectId}/batches/${batchId}/move-to-raw${queryParams}`,
    });
    yield put(Actions.setLoader({ showLoader: false }));
    notification('success', 'Images moved to raw successfully', '');
    if (callback) callback(true);
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err?.response?.data?.message || err?.message || 'Failed to move images to raw', '');
    if (callback) callback(false);
    console.warn(err);
  }
}

function* downloadBatch({ projectId, batchId, statusFilter }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));

    const queryParams = statusFilter ? `?statusFilter=${statusFilter}` : '';
    const response = yield call(api.get, {
      route: `VisionProjects/${projectId}/batches/${batchId}/download${queryParams}`,
    });

    // Create blob URL and trigger download
    const blob = new Blob([response.data], { type: 'application/zip' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `batch_${batchId}.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    yield put(Actions.setLoader({ showLoader: false }));
    notification('success', 'Download completed', '');
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    notification('error', err?.response?.data?.message || err?.message || 'Failed to download', '');
    console.warn(err);
  }
}

function* fetchBatchImages({ projectId, batchId }) {
  try {
    yield put(Actions.setLoader({ showLoader: true }));
    const { data } = yield call(api.get, {
      route: `VisionProjects/${projectId}/batches/${batchId}/images`,
    });
    const batchImages = data?.toJS ? data.toJS() : data ?? [];
    yield put(Actions.setBatchImages({ batchImages }));
    yield put(Actions.setLoader({ showLoader: false }));
  } catch (err) {
    yield put(Actions.setLoader({ showLoader: false }));
    yield put(Actions.setBatchImages({ batchImages: [] }));
    notification('error', err?.response?.data?.message || err?.message || 'Failed to fetch batch images', '');
    console.warn(err);
  }
}

export default function* rootSaga() {
  yield all([takeLatest(ActionTypes.FETCH_ALL, fetchAll)]);
  yield all([takeLatest(ActionTypes.FETCH_PROJECT_BY_ID, fetchProjectById)]);
  yield all([takeLatest(ActionTypes.FETCH_ALL_USE_CASES, fetchAllUseCases)]);
  yield all([takeLatest(ActionTypes.GET_VISION_PROJECT_VIDEOS, getVideos)]);
  yield all([takeLatest(ActionTypes.UPDATE_STEP, updateStep)]);
  yield all([takeLatest(ActionTypes.FETCH_TRAINING_DATA, fetchTrainingData)]);
  yield all([takeLatest(ActionTypes.START_TRAINING, startTraining)]);
  yield all([takeLatest(ActionTypes.STOP_TRAINING, stopTraining)]);
  yield all([takeLatest(ActionTypes.FETCH_TRAINING_PROGRESS, fetchTrainingProgress)]);
  yield all([takeLatest(ActionTypes.ADD_VISION_PROJECT, addVisionProject)]);
  yield all([takeLatest(ActionTypes.UPDATE_VISION_PROJECT, updateVisionProject)]);
  yield all([takeLatest(ActionTypes.DELETE_VISION_PROJECT, deleteVisionProject)]);
  yield all([takeLatest(ActionTypes.UPDATE_VISION_PROJECT_ARTWORK, updateVisionProjectArtwork)]);
  yield all([takeLatest(ActionTypes.DELETE_VISION_PROJECT_ARTWORK, deleteVisionProjectArtwork)]);
  yield all([takeLatest(ActionTypes.DELETE_VISION_PROJECT_VIDEO, deleteVisionProjectVideo)]);
  yield all([takeLatest(ActionTypes.DELETE_VISION_PROJECT_IMAGE, deleteVisionProjectImage)]);
  yield all([takeLatest(ActionTypes.DELETE_VISION_PROJECT_PRODUCT, deleteProductFromProject)]);
  yield all([takeLatest(ActionTypes.UPLOAD_VISION_PROJECT_IMAGES, uploadImages)]);
  yield all([takeLatest(ActionTypes.UPLOAD_VISION_PROJECT_VIDEO, uploadVideo)]);
  yield all([takeLatest(ActionTypes.UPLOAD_MEDIA, uploadMedia)]);
  yield all([takeLatest(ActionTypes.FETCH_VISION_PROJECT_IMAGES, fetchImages)]);
  yield all([takeLatest(ActionTypes.FETCH_IMAGE_ANNOTATIONS, fetchImageAnnotations)]);
  yield all([takeLatest(ActionTypes.ADD_ANNOTATIONS_TO_IMAGE, addAnnotationsToImage)]);
  yield all([takeLatest(ActionTypes.UPDATE_ANNOTATIONS_OF_IMAGE, updateAnnotationsOfImage)]);
  yield all([takeLatest(ActionTypes.SAVE_ANNOTATIONS_BULK, saveAnnotationsBulk)]);
  yield all([takeLatest(ActionTypes.DELETE_ANNOTATIONS_OF_IMAGE, deleteAnnotationsOfImage)]);
  yield all([takeLatest(ActionTypes.TEST_MODEL, testModel)]);
  yield all([takeLatest(ActionTypes.FETCH_TEST_RESULT, fetchTestResult)]);
  yield all([takeLatest(ActionTypes.CONFIGURE_PROJECT, configureProject)]);
  yield all([
    takeLatest(ActionTypes.FETCH_DEPLOYED_VISION_PROJECTS_BT_PRODUCT_ID, fetchDeployedVisionProjectsByProductId),
  ]);
  yield all([takeLatest(ActionTypes.DEPLOY_MODEL, deployModel)]);
  yield all([takeLatest(ActionTypes.REMOVE_IMAGE_ANNOTATIONS, removeAnnotations)]);
  yield all([takeLatest(ActionTypes.GET_VISION_PROJECT_DEPLOYMENT_HISTORY, getDeploymentHistory)]);
  yield all([takeLatest(ActionTypes.CHECK_CAMERA_STATUS, checkCameraStatus)]);
  yield all([takeLatest(ActionTypes.GET_IMAGE_FROM_S3_BUCKET, getImageFromS3Bucket)]);
  yield all([takeLatest(ActionTypes.IMAGE_CAPTURE_START, imageCaptureStartStop)]);
  yield all([takeLatest(ActionTypes.DELETE_SINGLE_IMAGE_FROM_S3, deleteSingleImageFromS3)]);
  yield all([takeLatest(ActionTypes.DELETE_ALL_IMAGES_FROM_S3_BUCKET, deleteAllImagesFromS3Bucket)]);
  yield all([takeLatest(ActionTypes.UPLOAD_IMAGES_TO_MONGODB, uploadImagesToMongoDb)]);
  yield all([takeLatest(ActionTypes.IS_IMAGE_CAPTURE_PROCESSED, isImageCaptureProcessed)]);
  yield all([takeLatest(ActionTypes.GET_VISION_PROJECT_TRAINING_HISTORY, getTrainingHistory)]);
  yield all([takeLatest(ActionTypes.GET_VISION_PROJECT_STATUS, getVisionProjectStatus)]);
  yield all([takeLatest(ActionTypes.FETCH_VISION_AI_TOOLS, fetchVisionAiTools)]);
  yield all([takeLatest(ActionTypes.SAVE_TEMP_ANNOTATION, saveTempAnnotation)]);
  yield all([takeLatest(ActionTypes.FETCH_TEMP_ANNOTATIONS, fetchTempAnnotations)]);
  yield all([takeLatest(ActionTypes.FETCH_TEMP_ANNOTATION_BY_IMAGE, fetchTempAnnotationByImage)]);
  // Global AOIs and Customer AOIs saga watchers
  yield all([takeLatest(ActionTypes.FETCH_ALL_GLOBAL_AOIS, fetchAllGlobalAois)]);
  yield all([takeLatest(ActionTypes.FETCH_CUSTOMER_AOIS, fetchCustomerAois)]);
  yield all([takeLatest(ActionTypes.FETCH_LABELS_LIST, fetchLabelsList)]);
  yield all([takeLatest(ActionTypes.SAVE_CUSTOMER_AOI_SELECTION, saveCustomerAoiSelection)]);
  yield all([takeLatest(ActionTypes.ADD_CUSTOMER_AOI, addCustomerAoi)]);
  yield all([takeLatest(ActionTypes.UPDATE_CUSTOMER_AOI, updateCustomerAoi)]);
  yield all([takeLatest(ActionTypes.DELETE_CUSTOMER_AOI, deleteCustomerAoi)]);
  yield all([takeLatest(ActionTypes.REMOVE_GLOBAL_AOI_SELECTION, removeGlobalAoiSelection)]);
  // Batch operations
  yield all([takeLatest(ActionTypes.FETCH_BATCHES, fetchBatches)]);
  yield all([takeLatest(ActionTypes.DELETE_BATCH, deleteBatch)]);
  yield all([takeLatest(ActionTypes.MARK_BATCH_AS_NULL, markBatchAsNull)]);
  yield all([takeLatest(ActionTypes.MOVE_BATCH_TO_RAW, moveBatchToRaw)]);
  yield all([takeLatest(ActionTypes.DOWNLOAD_BATCH, downloadBatch)]);
  yield all([takeLatest(ActionTypes.FETCH_BATCH_IMAGES, fetchBatchImages)]);
}
